import React from 'react';

const NoDataOverlay = () => (
    <div className="absolute inset-0 bg-white dark:bg-[#4a4a4a70] bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-10">
        <p className="text-lg text-gray-700 dark:text-gray-300 font-semibold">
            No data currently available
        </p>
    </div>
);

export default NoDataOverlay;